import { NODEVICEID } from "../../../../../model/DutyStatusLog";
import Message from "../../../../../model/Message";
import { EVENTS_DISPLAY_LIMIT } from "../../../../../sync/messages";
import { isSystemMessage, IGroup } from "../../../../../ui/messaging/helpers";

export const filterMessages = (messages: Message[], deviceId: string) => {
    let filteredMessages: Message[] = [];
    const isValidDeviceMessage = (msg: Message) => {
        return msg.device?.id !== NODEVICEID && msg.device?.id === deviceId;
    };

    filteredMessages = messages
        .filter(msg => isSystemMessage(msg) && isValidDeviceMessage(msg))
        .slice(0, EVENTS_DISPLAY_LIMIT); // Display only the first 50 messages

    return filteredMessages;
};

export const groupMessagesByDate = (messages: Message[]): IGroup[] => {
    const messageGroups = messages.reduce((groups: IGroup[], message: Message) => {
        const sentDate = message.getSentDate();
        if (sentDate) {
            if (!groups[sentDate]) {
                groups[sentDate] = [];
            }
            groups[sentDate].push(message);
        }
        return groups;
    }, new Array<IGroup>());

    return Object.keys(messageGroups).map((date) => {
        return { date: date, messages: messageGroups[date] } as IGroup;
    });
};